// extracted by mini-css-extract-plugin
module.exports = {"hero":"LoginModalHeader_hero__SOtug","default":"LoginModalHeader_default__jP4dV","closeButton":"LoginModalHeader_closeButton__QVUPl"};